import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './css/DesignTokens.css';
import './css/DesignSystem.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { UserProvider } from './Components/userContext';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ErrorProvider } from './Contexts/ErrorContext';
import ErrorPopup from './Components/Common/ErrorPopup';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <UserProvider>
    <ErrorProvider>
      <ErrorPopup />
      <App />
      </ErrorProvider>
    </UserProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
